export const API_URL = 'https://www.ziphap-api.ml';

const __DEV__ = false;
export const KAKAO_REDIRECT_URL = __DEV__ ? 'http://localhost:3000/kakao' : 'https://ziphap.swygbro.com/kakao';
export const BASE_URL = __DEV__ ? 'http://localhost:3000' : 'https://ziphap.swygbro.com';

export const GOOGLE_REDIRECT_URL = __DEV__ ? 'http://localhost:3000/google' : 'https://ziphap.swygbro.com/google';
